import { compose } from 'recompose';
import { connect } from 'react-redux';

import LatencyChart from '../../../../../components/Analytics/CannedCharts/HLECharts/LatencyChart';
import { fetchMetricsData } from '../../../../../actions/metrics';
import { CHART_HLE_LATENCY, HISTORICAL_METRIC_30DAYS,
  HISTORICAL_METRIC_52WEEKS } from '../../../../../constants/charts';
import { API_BASED } from '../../../../../constants/metrics';
import {
  getChartData,
  getApiMap,
  getAppMap,
  getOrgMap,
  getIsChartLoading,
  getIsMetricTypeDataLoading,
 } from '../../../../../reducers/metrics';

const defaultparams = {
  sortOrder: 'desc',
  sortBy: 'date',
  limit: [3],
  stats: ['max', 'min', 'avg'],
  timerange: 'week',
  buckets: ['apis'],
};
const path = 'latency';

export const mapDispatchToProps = (dispatch) => ({
  fetchMetricsData: () =>
    dispatch(
      fetchMetricsData(
        CHART_HLE_LATENCY,
        defaultparams,
        path,
        'by-day',
        API_BASED,
      ),
    ),
  fetchCustomDateMetricsData: (param) =>
    dispatch(
      fetchMetricsData(
        CHART_HLE_LATENCY,
        param,
        path,
        param.aggregation,
        API_BASED,
      ),
    ),
});

export const mapStateToProps = (state) => ({
  defaultLatencyResponse: getChartData(state, CHART_HLE_LATENCY),
  latencyResponseFor30DaysAgo: getChartData(state, CHART_HLE_LATENCY, HISTORICAL_METRIC_30DAYS),
  latencyResponseFor52WeeksAgo: getChartData(state, CHART_HLE_LATENCY, HISTORICAL_METRIC_52WEEKS),
  apiMap: getApiMap(state),
  appMap: getAppMap(state),
  orgMap: getOrgMap(state),
  isLoading: getIsChartLoading(state, CHART_HLE_LATENCY),
  is30DaysDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_HLE_LATENCY,
    HISTORICAL_METRIC_30DAYS,
  ),
  is52WeeksDataLoading: getIsMetricTypeDataLoading(
    state,
    CHART_HLE_LATENCY,
    HISTORICAL_METRIC_52WEEKS,
  ),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(LatencyChart);
